import Skeleton from "./Skeleton"

export default function FriendsLoading({}) {
  return (
    <div className="flex flex-1 flex-col px-4">
      <Skeleton w={280} h={36} style="my-3" />
      <Skeleton h={220} />
      <Skeleton w={200} h={36} style="my-3" />
      <Skeleton h={220} />
    </div>
  )
}
